import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Container, Grid, Col, Panel, Form, Button, ButtonToolbar, Loader } from 'rsuite';
import CampoSenha from '~/components/CampoSenha';
import api from '~/services/api';
import { deslogar } from '~/store/modulos/autenticacao/actions';
import { mensagemSenhaFraca, REGRA_SENHA_FORTE } from '~/utils/senhaForte';

export default function RedefinirSenhaAdministrador() {
  const dispatch = useDispatch();
  const token = new URLSearchParams(useLocation().search).get('token');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmacao, setConfirmacao] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function salvarSenha() {
    if (!token) {
      toast.error('Link inválido ou expirado');
      return;
    }

    const mensagem = mensagemSenhaFraca(novaSenha);
    if (mensagem) {
      toast.error(mensagem);
      return;
    }

    if (novaSenha !== confirmacao) {
      toast.error('A confirmação da senha não confere');
      return;
    }

    setEnviando(true);
    try {
      const resposta = await api.put('recuperar-senha/administrador', {
        token,
        senha: novaSenha,
        senhaConfirmacao: confirmacao,
      });
      toast.success(resposta.data.message);
      dispatch(deslogar());
    } catch (e) {
      toast.error(e.message);
    }
    setEnviando(false);
  }

  return (
    <div className="show-fake-browser login-page">
      <Container>
        <Grid>
          <Col mdOffset={6} md={12}>
            <Panel header={<h3>Redefinir senha</h3>} bordered>
              {!token && (
                <p>Link inválido ou expirado. Peça um novo na tela de login.</p>
              )}
              <Form fluid onSubmit={(semErro) => semErro && salvarSenha()}>
                <CampoSenha
                  label="Nova senha"
                  name="novaSenha"
                  value={novaSenha}
                  onChange={(valor) => setNovaSenha(valor)}
                />
                <CampoSenha
                  label="Confirmação da nova senha"
                  name="confirmacao"
                  value={confirmacao}
                  onChange={(valor) => setConfirmacao(valor)}
                />
                <p style={{ marginBottom: 16 }}>{REGRA_SENHA_FORTE}</p>
                <ButtonToolbar>
                  <Button
                    appearance="primary"
                    type="button"
                    block
                    disabled={enviando || !token}
                    onClick={() => salvarSenha()}
                  >
                    Salvar
                  </Button>
                </ButtonToolbar>
                {enviando && <Loader backdrop content="loading..." vertical />}
              </Form>
            </Panel>
          </Col>
        </Grid>
      </Container>
    </div>
  );
}
